import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "filterPaymentMethod",
})
export class FilterPaymentMethodPipe implements PipeTransform {
  transform(
    paymentGateways: any,
    currentUser: any,
    pickup: any,
    dinein: any,
    storeNetworkConnected: any
  ): any {
    const deliveryMethod = dinein
      ? "dinein"
      : pickup
      ? "takeaway"
      : "delivery";

    for (const key in paymentGateways) {
      if (
        (paymentGateways &&
          paymentGateways[key] &&
          paymentGateways[key].disable_payment_gateway) ||
        !(
          paymentGateways &&
          paymentGateways[key] &&
          paymentGateways[key].active &&
          (!paymentGateways[key].adminOnly ||
            (currentUser && currentUser.admin))
        ) ||
        !(
          paymentGateways &&
          paymentGateways[key] &&
          paymentGateways[key].active &&
          (!paymentGateways[key].customerOnly ||
            (currentUser &&
              ((currentUser.admin && paymentGateways[key].adminOnly) ||
                (currentUser.customerPaymentMethods &&
                  currentUser.customerPaymentMethods[key]))))
        ) ||
        (currentUser &&
          currentUser.disabledPaymentMethods &&
          currentUser.disabledPaymentMethods[key]) ||
        !this.isAudienceAllowed(
          paymentGateways[key],
          currentUser,
          deliveryMethod,
          storeNetworkConnected
        )
      ) {
        delete paymentGateways[key];
      }
    }
    return paymentGateways;
  }

  private isAudienceAllowed(
    method,
    currentUser,
    deliveryMethod,
    storeNetworkConnected
  ) {
    if (method.only_dinein && deliveryMethod === "dinein") {
      const isVisitor =
        currentUser?.only_dinein ||
        (currentUser?.only_visitor && currentUser?.visitor_mode === "dinein");
      return isVisitor
        ? this.isVisitorAudienceAllowed(
            method.dinein_visitors,
            storeNetworkConnected
          )
        : this.isDineInUserAudienceAllowed(
            method.dinein_users,
            storeNetworkConnected
          );
    }

    if (method.only_takeaway && deliveryMethod === "takeaway") {
      const isVisitor =
        currentUser?.only_visitor && currentUser?.visitor_mode === "takeaway";
      return isVisitor
        ? this.isVisitorAudienceAllowed(
            method.takeaway_visitors,
            storeNetworkConnected
          )
        : this.isDefaultUserAudienceAllowed(
            method.takeaway_users,
            storeNetworkConnected
          );
    }

    if (method.only_delivery && deliveryMethod === "delivery") {
      const isVisitor =
        currentUser?.only_visitor && currentUser?.visitor_mode === "delivery";
      return isVisitor
        ? this.isVisitorAudienceAllowed(
            method.delivery_visitors,
            storeNetworkConnected
          )
        : this.isDeliveryUserAudienceAllowed(
            method.delivery_users,
            storeNetworkConnected
          );
    }

    return true;
  }

  private isVisitorAudienceAllowed(audience, storeNetworkConnected) {
    return !!(
      audience?.all_visitors ||
      (audience?.only_network_visitors && storeNetworkConnected)
    );
  }

  private isDineInUserAudienceAllowed(audience, storeNetworkConnected) {
    if (!audience) {
      return true;
    }

    return !!(
      audience.all_users ||
      (audience.only_network_users && storeNetworkConnected)
    );
  }

  private isDefaultUserAudienceAllowed(audience, storeNetworkConnected) {
    return !!(
      audience?.all_users ||
      !audience?.only_network_users ||
      storeNetworkConnected
    );
  }

  private isDeliveryUserAudienceAllowed(audience, storeNetworkConnected) {
    if (!audience) {
      return true;
    }

    return !!(
      audience.all_users ||
      (audience.only_network_users && storeNetworkConnected)
    );
  }
}
